module.exports = __webpack_public_path__ + "img/add_2.96b05672.png";